import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { loadRolePermission } from "../app/store/auth";
import { addEditPermission } from "../app/store/users";

function AddEditPermission(props) {
  const { roleid, roleSource, handlePermissionShowHide } = props;
  const dispatch = useDispatch();
  const [state, setState] = useState({
    isSaving: false,
    permissionData: [],
    mainMenu: [],
    systemAdminstration: [
      "Authorized Users",
      "Main Users",
      "Manage Entites",
      "Subcontractors",
      "Recruiters",
      "Candidates",
      "Access To External System",
    ],
    menuObjects: [
      {
        id: 1,
        name: "SYSTEM ADMINISTRATION",
        menus: [
          {
            id: 1,
            name: "Authorized Users",
            menus: [{ id: 1, name: "Main Users", isChecked: false }],
            isChecked: false,
          },
          {
            id: 2,
            name: "Manage Entites",
            menus: [
              { id: 1, name: "Subcontractors", isChecked: false },
              { id: 2, name: "Recruiters", isChecked: false },
              { id: 3, name: "Candidates", isChecked: false },
            ],
            isChecked: false,
          },
        ],
        isChecked: false,
      },
      {
        id: 2,
        name: "ONBOARDING AND CONTRACTS",
        menus: [
          { id: 1, name: "Subcontractors" },
          { id: 2, name: "Recruiters" },
          { id: 3, name: "Candidates" },
        ],
      },
      {
        id: 3,
        name: "INVOICES",
        menus: [
          { id: 1, name: "Time Log Management" },
          { id: 2, name: "Invoices and Payments" },
        ],
      },
      {
        id: 4,
        name: "ANALYTICS",
        menus: [
          { id: 1, name: "Dashboard" },
          { id: 2, name: "Entity Data" },
          { id: 3, name: "Business Reports" },
          // { id: 4, name: "Query Based Reports" },
          { id: 5, name: "Compliance Reports / Docs" },
        ],
      },
      {
        id: 5,
        name: "SECURITY",
        menus: [
          { id: 1, name: "Monitoring Logs" },
          // { id: 2, name: "Single Sign On" },
        ],
      },
      {
        id: 6,
        name: "COMMUNICATION",
        menus: [
          {
            id: 1,
            name: "Emails",
            menus: [
              { id: 1, name: "Subcontractors", isChecked: false },
              { id: 2, name: "Recruiters", isChecked: false },
              { id: 3, name: "Candidates", isChecked: false },
            ],
            isChecked: false,
          },
          {
            id: 2,
            name: "Text Messages",
            menus: [
              { id: 1, name: "Subcontractors", isChecked: false },
              { id: 2, name: "Recruiters", isChecked: false },
              { id: 3, name: "Candidates", isChecked: false },
            ],
            isChecked: false,
          },
          {
            id: 3,
            name: "Surveys",
            menus: [
              { id: 1, name: "Surveys", isChecked: false },
            ],
            isChecked: false,
          },
        ],
        isChecked: false,
      },
    ],
    refMenuObjects: [
      {
        id: 1,
        name: "SYSTEM ADMINISTRATION",
        menus: [
          {
            id: 1,
            name: "Authorized Users",
            menus: [{ id: 1, name: "Main Users", isChecked: false }],
            isChecked: false,
          },
          {
            id: 2,
            name: "Manage Entites",
            menus: [
              { id: 1, name: "Subcontractors", isChecked: false },
              { id: 2, name: "Recruiters", isChecked: false },
              { id: 3, name: "Candidates", isChecked: false },
            ],
            isChecked: false,
          },
        ],
        isChecked: false,
      },
      {
        id: 2,
        name: "ONBOARDING AND CONTRACTS",
        menus: [
          { id: 1, name: "Subcontractors" },
          { id: 2, name: "Recruiters" },
          { id: 3, name: "Candidates" },
        ],
      },
      {
        id: 3,
        name: "INVOICES",
        menus: [
          { id: 1, name: "Time Log Management" },
          { id: 2, name: "Invoices and Payments" },
        ],
      },
      {
        id: 4,
        name: "ANALYTICS",
        menus: [
          { id: 1, name: "Dashboard" },
          { id: 2, name: "Entity Data" },
          { id: 3, name: "Business Reports" },
          // { id: 4, name: "Query Based Reports" },
          { id: 5, name: "Compliance Reports / Docs" },
        ],
      },
      {
        id: 5,
        name: "SECURITY",
        menus: [
          { id: 1, name: "Monitoring Logs" },
          // { id: 2, name: "Single Sign On" },
        ],
      },
      {
        id: 6,
        name: "COMMUNICATION",
        menus: [
          {
            id: 1,
            name: "Emails",
            menus: [
              { id: 1, name: "Subcontractors", isChecked: false },
              { id: 2, name: "Recruiters", isChecked: false },
              { id: 3, name: "Candidates", isChecked: false },
            ],
            isChecked: false,
          },
          {
            id: 2,
            name: "Text Messages",
            menus: [
              { id: 1, name: "Subcontractors", isChecked: false },
              { id: 2, name: "Recruiters", isChecked: false },
              { id: 3, name: "Candidates", isChecked: false },
            ],
            isChecked: false,
          },
          {
            id: 3,
            name: "Surveys",
            menus: [
              { id: 1, name: "Surveys", isChecked: false },
            ],
            isChecked: false,
          },
        ],
        isChecked: false,
      },
    ],
  });
  const refMenuObjectsRef = useRef(state.refMenuObjects);

  const renderSwitch = (label, name, handleOnChange, isChecked) => {
    return (
      <div className="permission-check-wrap">
        <div className="custom-control custom-switch permission-check">
          <input
            className="custom-control-input permission-check-input"
            id={name}
            type="checkbox"
            name={name}
            value="Yes"
            onChange={handleOnChange}
            checked={isChecked}
          />

          <label
            className="custom-control-label form-control-label permission-check-label"
            htmlFor={name}
          >
            {label}
          </label>
        </div>
      </div>
    );
  };

  const handleSystemAdminChange = ({ currentTarget }) => {
    const mid = currentTarget.id.split("_");
    const checked = currentTarget.checked;

    setState((currentState) => {
      const menuObjects = JSON.parse(JSON.stringify(currentState.menuObjects));

      if (mid[0] === "m") {
        const menu = menuObjects.find((x) => x.id === parseInt(mid[1]));
        if (menu) {
          menu.isChecked = checked;
          if (menu.menus) {
            menu.menus.forEach((smenu) => {
              smenu.isChecked = checked;
              if (smenu.menus) {
                smenu.menus.forEach((ssmenu) => {
                  ssmenu.isChecked = checked;
                });
              }
            });
          }
        }
      }

      if (mid[0] === "sm") {
        const menu = menuObjects.find((x) => x.id === parseInt(mid[2]));
        const smenu = menu && menu.menus
          ? menu.menus.find((x) => x.id === parseInt(mid[1]))
          : null;
        if (smenu) {
          smenu.isChecked = checked;
          if (smenu.menus) {
            smenu.menus.forEach((ssmenu) => {
              ssmenu.isChecked = checked;
            });
          }
        }
      }

      if (mid[0] === "ssm") {
        const menu = menuObjects.find((x) => x.id === parseInt(mid[3]));
        const smenu = menu && menu.menus
          ? menu.menus.find((x) => x.id === parseInt(mid[2]))
          : null;
        const ssmenu = smenu && smenu.menus
          ? smenu.menus.find((x) => x.id === parseInt(mid[1]))
          : null;
        if (ssmenu) {
          ssmenu.isChecked = checked;
        }
      }

      return { ...currentState, menuObjects };
    });
  };

  const closePermissionPanel = useCallback(
    (isSaved = false) => {
      handlePermissionShowHide(isSaved);
    },
    [handlePermissionShowHide]
  );

  const handleSubmit = async () => {
    const { menuObjects } = state;
    const permissionObj = {
      roleId: roleid,
      roleSource: roleSource,
      permissionRights: JSON.stringify(menuObjects),
    };
    setState((currentState) => ({ ...currentState, isSaving: true }));
    let isSaved = false;
    try {
      await dispatch(addEditPermission(permissionObj));
      isSaved = true;
    } catch (ex) {
      console.error(ex);
    } finally {
      setState((currentState) => ({ ...currentState, isSaving: false }));
    }

    if (isSaved) closePermissionPanel(true);
  };

  useEffect(() => {
    let isMounted = true;
    const refMenuObjects = refMenuObjectsRef.current;

    async function loadRolePermissions() {
      if (roleid > 0) {
        const data = await dispatch(loadRolePermission(roleid, roleSource));
        if (!isMounted) return;

        setState((currentState) => ({
          ...currentState,
          menuObjects: data !== "" ? data : JSON.parse(JSON.stringify(refMenuObjects)),
        }));
      } else {
        setState((currentState) => ({
          ...currentState,
          menuObjects: JSON.parse(JSON.stringify(refMenuObjects)),
        }));
      }
    }

    loadRolePermissions();

    return () => {
      isMounted = false;
    };
  }, [dispatch, roleid, roleSource]);

  const { menuObjects, isSaving } = state;
  return (
    <React.Fragment>
      <style>{`
          .permission-shell {
            background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
            border: 1px solid #e2e8f0;
            border-radius: 14px;
            overflow: hidden;
            margin-top: 8px;
          }

          .permission-toolbar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            padding: 14px 16px;
            border-bottom: 1px solid #eef2f7;
            background: #ffffff;
            flex-wrap: wrap;
          }

          .permission-title {
            display: flex;
            align-items: center;
            gap: 10px;
            margin: 0;
            color: #1e293b;
            font-size: 15px;
          }

          .permission-title-icon {
            width: 34px;
            height: 34px;
            border-radius: 10px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: #2563eb;
            background: rgba(37, 99, 235, 0.08);
            border: 1px solid rgba(37, 99, 235, 0.14);
          }

          .permission-back-header-btn {
            width: 34px;
            height: 34px;
            border-radius: 10px;
            border: 1.5px solid #e2e8f0;
            background: #ffffff;
            color: #475569;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s ease;
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
            outline: none;
          }
          .permission-back-header-btn:hover:not(:disabled) {
            border-color: #cbd5e1;
            background: #f8fafc;
            color: #0f172a;
            transform: translateX(-2px);
          }
          .permission-back-header-btn:disabled {
            background: #f1f5f9;
            color: #cbd5e1;
            border-color: #e2e8f0;
            cursor: not-allowed;
          }

          .permission-summary {
            display: inline-flex;
            align-items: center;
            gap: 7px;
            color: #047857;
            background: rgba(16, 185, 129, 0.08);
            border: 1px solid rgba(16, 185, 129, 0.18);
            border-radius: 999px;
            padding: 6px 12px;
            font-size: 12px;
          }

          .permission-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 14px;
            padding: 16px;
          }

          .permission-card {
            border: 1px solid #e2e8f0;
            border-radius: 12px;
            background: #ffffff;
            box-shadow: 0 2px 10px rgba(15, 23, 42, 0.04);
            overflow: hidden;
            transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .permission-card:hover {
            border-color: #cbd5e1;
            transform: translateY(-2px);
            box-shadow: 0 10px 20px rgba(15, 23, 42, 0.06);
          }

          .permission-card-header {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 12px 14px;
            background: linear-gradient(90deg, #f8fafc 0%, #ffffff 100%);
            border-bottom: 1px solid #eef2f7;
          }

          .permission-card-icon {
            width: 30px;
            height: 30px;
            border-radius: 9px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            background: #171717;
            flex: 0 0 auto;
          }

          .permission-card-body {
            padding: 12px 14px 14px;
          }

          .permission-section {
            border: 1px solid #f1f5f9;
            border-radius: 10px;
            padding: 10px 10px 8px;
            margin-bottom: 10px;
            background: #fbfdff;
          }

          .permission-section:last-child {
            margin-bottom: 0;
          }

          .permission-child-list {
            margin: 8px 0 0 22px;
            padding: 0;
            list-style: none;
          }

          .permission-child-item {
            padding: 5px 0;
          }

          .permission-check-wrap {
            width: 100%;
          }

          .permission-check {
            min-height: 20px;
            display: flex;
            align-items: center;
            padding-left: 0;
          }

          .permission-check-label {
            color: #334155;
            font-size: 13px;
            line-height: 1.35;
            cursor: pointer;
            display: flex;
            align-items: center;
            min-height: 24px;
            padding-left: 48px;
          }

          .permission-check-label.form-control-label {
            font-weight: 400 !important;
          }

          .permission-check .custom-control-label::before,
          .permission-check .custom-control-label::after {
            top: 50%;
            transform: translateY(-50%);
          }

          .permission-check .custom-control-label::before {
            left: 0;
            width: 38px;
            height: 22px;
            border-radius: 999px;
            border: 1.5px solid #ef4444 !important;
            background-color: #ef4444 !important;
            transition: all 0.2s ease !important;
          }

          .permission-check .custom-control-label::after {
            left: 3px;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background: #ffffff !important;
            background-image: none !important;
            box-shadow: 0 1px 3px rgba(15, 23, 42, 0.25);
            transition: transform 0.2s ease !important;
          }

          .permission-check-input:checked ~ .custom-control-label::before {
            border-color: #22c55e !important;
            background-color: #22c55e !important;
          }

          .permission-check-input:checked ~ .custom-control-label::after {
            transform: translate(16px, -50%) !important;
          }

          .permission-card-header .permission-check-label {
            color: #1e293b;
            font-size: 13.5px;
            text-transform: uppercase;
            letter-spacing: 0.35px;
          }

          .permission-actions {
            display: flex;
            justify-content: center;
            gap: 12px;
            padding: 14px 16px 16px;
            border-top: 1px solid #eef2f7;
            background: #ffffff;
          }

          .permission-cancel-btn {
            min-height: 38px; display: inline-flex; align-items: center; justify-content: center;
            gap: 8px; font-size: 13px; border-radius: 8px;
            cursor: pointer; transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            padding: 8px 16px; border: 1.5px solid #cbd5e1; outline: none;
            background: #ffffff; color: #475569;
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
          }
          .permission-cancel-btn:hover:not(:disabled) {
            background: #f8fafc; border-color: #94a3b8; color: #1e293b;
            transform: translateY(-1px);
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          }
          .permission-cancel-btn:disabled {
            background: #f1f5f9; color: #94a3b8; border-color: #cbd5e1;
            cursor: not-allowed; opacity: 0.75;
          }

          .permission-save-btn {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            border: 1px solid #2563eb;
            border-radius: 9px;
            background: #2563eb;
            color: #ffffff;
            padding: 9px 22px;
            font-size: 13px;
            cursor: pointer;
            transition: all 0.2s ease;
          }

          .permission-save-btn:hover:not(:disabled) {
            background: #1d4ed8;
            border-color: #1d4ed8;
            transform: translateY(-1px);
            box-shadow: 0 8px 18px rgba(37, 99, 235, 0.22);
          }

          .permission-save-btn:focus,
          .permission-save-btn:active {
            outline: none;
            box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.14);
          }

          .permission-save-btn:disabled {
            background: #cbd5e1;
            color: #94a3b8;
            border-color: #cbd5e1;
            cursor: not-allowed;
            opacity: 0.85;
          }
        `}</style>

      <div className="permission-shell">
        <div className="permission-grid">
          {menuObjects.map((menu) => (
            <div className="permission-card" key={menu.id}>
              <div className="permission-card-header">
                {renderSwitch(
                  menu.name,
                  `m_${menu.id}`,
                  handleSystemAdminChange,
                  menu.isChecked
                )}
              </div>
              <div className="permission-card-body">
                {menu.menus?.map((smenu) => (
                  <div className="permission-section" key={smenu.id}>
                    {renderSwitch(
                      smenu.name,
                      `sm_${smenu.id}_${menu.id}`,
                      handleSystemAdminChange,
                      smenu.isChecked
                    )}
                    {smenu.menus?.length > 0 && (
                      <ul className="permission-child-list">
                        {smenu.menus.map((ssmenu) => (
                          <li className="permission-child-item" key={ssmenu.id}>
                            {renderSwitch(
                              ssmenu.name,
                              `ssm_${ssmenu.id}_${smenu.id}_${menu.id}`,
                              handleSystemAdminChange,
                              ssmenu.isChecked
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="permission-actions">
          <button
            type="button"
            className="permission-cancel-btn"
            onClick={() => closePermissionPanel(false)}
            disabled={isSaving}
          >
            <i className="fa fa-arrow-left" aria-hidden="true" /> Back
          </button>
          <button
            type="button"
            className="permission-save-btn"
            onClick={handleSubmit}
            disabled={isSaving}
          >
            {isSaving ? (
              <>
                <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true" /> Saving...
              </>
            ) : (
              <>
                <i className="fa fa-check" aria-hidden="true" /> Save Permissions
              </>
            )}
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}

export default AddEditPermission;
